import { render, staticRenderFns } from "./imgsParam.vue?vue&type=template&id=2fb22356&scoped=true&"
import script from "./imgsParam.vue?vue&type=script&lang=js&"
export * from "./imgsParam.vue?vue&type=script&lang=js&"
import style0 from "./imgsParam.vue?vue&type=style&index=0&id=2fb22356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb22356",
  null
  
)

export default component.exports